export default {
  Circle: "circle",
  Line: "line",
  Arrow: "arrow",
  Pencil: "pencil",
  Eraser: "eraser",
  Rectangle: "rectangle",
  Select: "select",
  Pan: "pan",
  None: "none",
  Text: "text"
};
